import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { IAlertRuleRecord } from "src/app/main/modules/alerts/_models/alerts.interfaces";
import { IPowerLossAlertDetailData, PowerLossAlertDetailService } from
    "src/app/main/modules/alerts/components/alert-detail/power-loss-alert-detail/power-loss-alert-detail.service";

@Component({
    selector: "power-loss-alert-detail",
    template: require("./power-loss-alert-detail.component.html")
})
export class PowerLossAlertDetailComponent implements OnChanges {

    @Input()
    record: IAlertRuleRecord;
    @Input()
    tableMode: boolean = false;

    updating = false;

    alertDetailData: IPowerLossAlertDetailData;
    tableModeLabel: string;

    debounceTimeout: any;

    constructor(
        private readonly alertDetailService: PowerLossAlertDetailService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }

        this.debounceTimeout = setTimeout(() => {
                this.getPowerLossData();
                this.debounceTimeout = null;
            },
            100);
    }

    private getPowerLossData() {
        this.updating = true;

        this.alertDetailService.getAlertData(this.record)
            .then((data) => {
                this.updating = false;
                this.alertDetailData = data;
                this.tableModeLabel = this.alertDetailService.createAlertLabel(this.alertDetailData);
            });
    }
}
